import React from 'react'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'; 

const Menu = (props) => (
    <nav id="menu">
        <div className="inner">
            <ul className="links">
				<li><Link onClick={props.onToggleMenu} to="/creation-sites-internet-et-applications/">Sites & Applis <i className="icon fa-chevron-down"></i></Link></li>
				<ul className="sublinks">
					<li><Link onClick={props.onToggleMenu} to="/pack-e-commerce/">Pack Site Vitrine</Link></li>
					<li><Link onClick={props.onToggleMenu} to="/pack-e-commerce/">Pack E-commerce</Link></li>
				</ul>
				<li><Link onClick={props.onToggleMenu} to="/assistance-informatique/">Assistance</Link></li>
				<li><Link onClick={props.onToggleMenu} to="/infrastructure-informatique/">Infrastructure</Link></li>
				<li><Link onClick={props.onToggleMenu} to="/hotspots-wifi/">Hotspots Wifi</Link></li>
				<li><Link onClick={props.onToggleMenu} to="/cv/">Mon CV</Link></li>
            </ul>
        </div>
        <a className="close" onClick={props.onToggleMenu} href="javascript:;">Close</a>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js